import { SaveIcon } from '@blocksuite/icons/rc';
import { Button } from '@pique/component';
import type { Collection } from '@pique/env/filter';
import { useI18n } from '@pique/i18n';
import { nanoid } from 'nanoid';
import { useCallback } from 'react';

import { createEmptyCollection } from '../use-collection-manager';
import * as styles from './save-as-collection-button.css';
import { useEditCollectionName } from './use-edit-collection';

interface SaveAsCollectionButtonProps {
  onConfirm: (collection: Collection) => void;
}

export const SaveAsCollectionButton = ({
  onConfirm,
}: SaveAsCollectionButtonProps) => {
  const t = useI18n();
  const { open, node } = useEditCollectionName({
    title: t['com.pique.editCollection.saveCollection'](),
    showTips: true,
  });
  const handleClick = useCallback(() => {
    open('')
      .then(name => {
        return onConfirm(createEmptyCollection(nanoid(), { name }));
      })
      .catch(err => {
        console.error(err);
      });
  }, [open, onConfirm]);
  return (
    <>
      <Button
        onClick={handleClick}
        data-testid="save-as-collection"
        prefix={<SaveIcon />}
        className={styles.button}
      >
        {t['com.pique.editCollection.saveCollection']()}
      </Button>
      {node}
    </>
  );
};
